import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PagamentoDespesaPagarComponent } from './pagamento-despesa-pagar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: PagamentoDespesaPagarComponent }
    ])],
    exports: [RouterModule]
})
export class PagamentoDespesaPagarRoutingModule { }
